import { StateNode, TLKeyboardEventInfo, TLPointerEventInfo } from "tldraw"

export class ArrowIdle extends StateNode {
  static override id = "arrow2-idle"

  override onPointerDown(info: TLPointerEventInfo) {
    this.parent.transition("arrow-pointing", info)
  }

  override onEnter() {
    this.editor.setCursor({ type: "cross", rotation: 0 })
  }

  override onCancel() {
    this.editor.setCurrentTool("select")
  }

  override onKeyUp(info: TLKeyboardEventInfo) {
    if (info.key === "Enter") {
      if (this.editor.getIsReadonly()) return null
      const onlySelectedShape = this.editor.getOnlySelectedShape()
      // If the only selected shape is editable, start editing it
      if (
        onlySelectedShape &&
        this.editor.getShapeUtil(onlySelectedShape).canEdit(onlySelectedShape)
      ) {
        this.editor.setCurrentTool("select")
        this.editor.setEditingShape(onlySelectedShape.id)
        this.editor.root.getCurrent()?.transition("editing_shape", {
          ...info,
          target: "shape",
          shape: onlySelectedShape,
        })
      }
    }
  }
}
